import { defineStore } from 'pinia';
import { ref } from 'vue';

// 医院側「見積一覧」フローの画面間共有状態。
// 見積患者選択 → 見積一覧 → 見積編集 → 契約一覧 の各画面で、選択中の患者IDと
// 患者検索条件（検索文字列・ページ・件数）を保持する。
// 検索条件を保持するのは、患者詳細から戻ってきた時に前回検索結果を再表示するため。
export const useEstimateStore = defineStore('estimate', () => {
  const selectedPatientId = ref<number | null>(null);

  // 患者検索の最後の状態（戻り時に復元）【見積側】
  const patientSearchQuery = ref<string>('');
  const patientSearchPage = ref<number>(1);
  const patientSearchPageSize = ref<number>(20);
  const patientSearchSubmitted = ref<boolean>(false);

  // 契約側の検索状態（見積側とは独立、それぞれで別に保持）
  const contractSearchQuery = ref<string>('');
  const contractSearchPage = ref<number>(1);
  const contractSearchPageSize = ref<number>(20);
  const contractSearchSubmitted = ref<boolean>(false);

  // コンサルティング側の検索状態（見積/契約とは独立）
  const consultingSearchQuery = ref<string>('');
  const consultingSearchPage = ref<number>(1);
  const consultingSearchPageSize = ref<number>(20);
  const consultingSearchSubmitted = ref<boolean>(false);

  function setSelectedPatientId(id: number | null) {
    selectedPatientId.value = id;
  }

  function clearSelectedPatientId() {
    selectedPatientId.value = null;
  }

  function setPatientSearchState(state: {
    query: string;
    page: number;
    pageSize: number;
    submitted: boolean;
  }) {
    patientSearchQuery.value = state.query;
    patientSearchPage.value = state.page;
    patientSearchPageSize.value = state.pageSize;
    patientSearchSubmitted.value = state.submitted;
  }

  function clearPatientSearchState() {
    patientSearchQuery.value = '';
    patientSearchPage.value = 1;
    patientSearchPageSize.value = 20;
    patientSearchSubmitted.value = false;
  }

  function setContractSearchState(state: {
    query: string;
    page: number;
    pageSize: number;
    submitted: boolean;
  }) {
    contractSearchQuery.value = state.query;
    contractSearchPage.value = state.page;
    contractSearchPageSize.value = state.pageSize;
    contractSearchSubmitted.value = state.submitted;
  }

  function clearContractSearchState() {
    contractSearchQuery.value = '';
    contractSearchPage.value = 1;
    contractSearchPageSize.value = 20;
    contractSearchSubmitted.value = false;
  }

  function setConsultingSearchState(state: {
    query: string;
    page: number;
    pageSize: number;
    submitted: boolean;
  }) {
    consultingSearchQuery.value = state.query;
    consultingSearchPage.value = state.page;
    consultingSearchPageSize.value = state.pageSize;
    consultingSearchSubmitted.value = state.submitted;
  }

  function clearConsultingSearchState() {
    consultingSearchQuery.value = '';
    consultingSearchPage.value = 1;
    consultingSearchPageSize.value = 20;
    consultingSearchSubmitted.value = false;
  }

  return {
    selectedPatientId,
    setSelectedPatientId,
    clearSelectedPatientId,
    patientSearchQuery,
    patientSearchPage,
    patientSearchPageSize,
    patientSearchSubmitted,
    setPatientSearchState,
    clearPatientSearchState,
    contractSearchQuery,
    contractSearchPage,
    contractSearchPageSize,
    contractSearchSubmitted,
    setContractSearchState,
    clearContractSearchState,
    consultingSearchQuery,
    consultingSearchPage,
    consultingSearchPageSize,
    consultingSearchSubmitted,
    setConsultingSearchState,
    clearConsultingSearchState,
  };
});
